import axios from 'axios';
import { TIMEOUTS } from '@/lib/constants';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Stable, module-singleton axios instance.
 * Identity never changes across renders, so it is safe to omit
 * from React hook dependency arrays.
 */
const apiClient = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  timeout: TIMEOUTS.REQUEST_TIMEOUT_MS,
});

export default apiClient;
export { API_BASE };
